import React from "react";
import { Button } from "main/components/ui-components/Button";
import { Link } from "react-router-dom";
import home3 from "../../../../src/main/assets/images/Images/Home-Images/home_3png.png";
import learnMore from "../../../../src/main/assets/images/Images/Home-Images/LearnMore.png";

type Props = {};

const LearnMore = (props: Props) => {
  return (
    <>
      {/* Mobile */}
      <div className="d-block d-md-none">
        <div
          className="col-12 col-md-12 col-sm-12"
          style={{
            backgroundImage: `url(${home3})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="container">
            <div className="d-flex justify-content-center flex-column align-items-center py-20">
              <div className="col-12 col-md-12 col-sm-12 text-center py-40">
                <h1 className="line-23 justify-content-center fonts-800 text-white-color font-20 wp-105 font-family-roboto landing-heading-width pb-20">
                  Learn More About Yantr.ai
                </h1>
                <p className="fonts-400 px-20 font-13 line-18 landing-heading-width justify-content-center text-white-color font-family-roboto pb-40">
                  Explore how you can improve your supply chain operations,
                  field services planning and execution with Yantr.ai’s AI
                  driven solutions.
                </p>
                <p className="fonts-400 font-13 line-18 landing-heading-width justify-content-center text-white-color font-family-roboto pb-30">
                  Schedule a demo today with our product experts!
                </p>
                {/* <div className="d-flex align-items-end h-100 mt-20 mb-20 font-16 fonts-500 line-19 justify-content-center">
              <Link to={"/contact-us"}>
                <Button
                  className="py-12 px-4 font-16 fonts-500 justify-content-center text-white-color font-family-roboto-flex"
                  onClick={() => {}}
                >
                  Contact Us
                </Button>
              </Link>
            </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* website */}
      <div className="d-none d-md-block">
        <div
          className="col-12 col-md-12 col-sm-12"
          style={{
            backgroundImage: `url(${learnMore})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="container">
            <div className="d-flex justify-content-center flex-column align-items-center py-20">
              <div className="col-12 col-md-12 col-sm-12 text-center py-40">
                <h1 className="line-35 justify-content-center fonts-800 text-white-color font-30 wp-105 font-family-roboto landing-heading-width pb-20">
                  Learn More About Yantr.ai
                </h1>
                <p className="fonts-400 px-50 mx-50 font-22 line-26 landing-heading-width justify-content-center text-white-color font-family-roboto pb-40">
                  Explore how you can improve your supply chain operations,
                  field services planning and execution with Yantr.ai’s AI
                  driven solutions.
                </p>
                <p className="fonts-400 font-22 line-26 landing-heading-width justify-content-center text-white-color font-family-roboto pb-30">
                  Schedule a demo today with our product experts!
                </p>
                <div className="d-flex align-items-end h-100 mt-20 font-16 fonts-500 line-19 justify-content-center">
                  <Link to={"/contact-us"}>
                    <Button
                      className="py-12 px-4 font-16 fonts-500 justify-content-center text-white-color font-family-roboto-flex"
                      onClick={() => {}}
                    >
                      Contact Us
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LearnMore;
